import tippy from "tippy.js";

export const tooltip = (el, { expression }) => {
  tippy(el, { content: expression, allowHTML: true, arrow: false });
};

export const tooltipDelay = (el, { expression }) => {
  tippy(el, {
    content: expression,
    allowHTML: true,
    arrow: false,
    delay: [250, 0],
  });
};

export const tooltipDelayArrow = (el, { expression }) => {
  tippy(el, {
    content: expression,
    allowHTML: true,
    arrow: true,
    delay: [250, 0],
  });
};

export const tooltipIfTruncated = (e, fullText) => {
  const el = e.target;

  if (el && el.offsetWidth < el.scrollWidth) {
    if (el._tippy) el._tippy.destroy(); // Clear first to prevent pile up of instances

    tippy(el, {
      content: fullText,
      delay: [250, 0],
    });
  }
};
